import { handleActions } from 'redux-actions';
import { OnboardingState } from './interfaces';
import {
  SET_JUST_COMPLETED_ONBOARDING,
  SetJustCompletedOnboarding,
  SetAudienceExtractorChannel,
  SET_AUDIENCE_EXTRACTOR_CHANNEL,
} from './actions';
import sessionCRUDActions from '../../actions/SessionCRUDActions';

const initialState: OnboardingState = {
  justCompletedOnboarding: false,
  audienceExtractorChannel: undefined,
};

const setJustCompletedOnboarding = (
  state: OnboardingState,
  action: any,
): OnboardingState => {
  const { justCompletedOnboarding } = action as SetJustCompletedOnboarding;

  return {
    ...state,
    justCompletedOnboarding,
  };
};

const setAudienceExtractorChannel = (
  state: OnboardingState,
  action: any,
): OnboardingState => {
  const { audienceExtractorChannel } = action as SetAudienceExtractorChannel;

  return {
    ...state,
    audienceExtractorChannel,
  };
};

const mappedReducers = {
  [SET_JUST_COMPLETED_ONBOARDING]: setJustCompletedOnboarding,
  [SET_AUDIENCE_EXTRACTOR_CHANNEL]: setAudienceExtractorChannel,
  [sessionCRUDActions.clearSessionAction]: () => initialState,
};

const onboardingState = handleActions(mappedReducers, initialState);

export default onboardingState;
